export default "__VITE_ASSET__CXgRhvf___"